import { from } from "@vueuse/rxjs";
import { Ref } from "vue";
import { Observable, concat } from "rxjs";

export type ObservableReturnType<Type> = Type extends Observable<infer X> ? X : never;

export function fromWithCurrent<T>(a: Ref<T>): Observable<T> {
    return concat(from<T>([a.value]), from<T>(a));
}
